<template>
    <main class="main-section">
        <SoinsAFaire />
    </main>
</template>

<script>
import SoinsAFaire from './index.vue'

export default {
    name: 'page-soins-a-faire-infirmier',
    components: { SoinsAFaire }
}
</script>
